import './app.less'

import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom'

import {getUser, onUserChange} from './helpers/session';
import ClientsList from './components/pages/clients/list';
import ReqClientsList from './components/pages/clients/req-list';

import {inject, observer} from 'mobx-react';
import {ClientsStats} from './components/pages/clients/stats';
import {Managers} from './components/pages/admin/managers';
import ArchiveClientsList from './components/pages/clients/arc-list';
import Login from './components/pages/auth/login';
import Sign from './components/pages/auth/sign';
import UserCars from './components/pages/user/user-cars';
import {Crm} from './components/pages/crm/crm';

const SmartRoute = (props) => {
  return props.enabled ? <Route {...props}/> : <Redirect to={props.redirectTo} />;
};

const LoginRoute = (props) => {
  const user = props.user && props.user.user;
  return <SmartRoute {...props} enabled={!user || user.status !== 'active'} redirectTo={'/'} />
};

const ProtectedRoute = (props) => {
  const user = props.user && props.user.user;
  if (user && user.status === 'active') {
    return <Route {...props} />;
  } else if (user && user.status === 'registered') {
    return <Redirect to={'/sign'} />
  } else {
    return <Redirect to={'/login'} />;
  }
};

const ManagerRoute = (props) => {
  const user = props.user && props.user.user;

  if (user && (user.type === 'manager' || user.type === 'admin')) {
    return <ProtectedRoute {...props} />;
  } else {
    return <Redirect to={'/'} />
  }
};

const AdminRoute = (props) => {
  return <SmartRoute {...props} enabled={props.user && props.user.user && props.user.user.type === 'admin'} redirectTo={'/login'} />
};

@inject('loginStore')
class App extends Component {
  state = {

  };

  componentDidMount() {
    onUserChange(::this.onUserChanged);
    this.props.loginStore.loadUserState();
  }

  onUserChanged(newUser) {
    this.setState({ user: newUser });
  }

  render() {
    return this.state.user !== undefined ? this.renderRouter() : <div>Loading..</div>;
  }

  renderRouter() {
    return (
      <Switch>
        <LoginRoute exact path="/login" component={Login} user={this.state.user} />
        <LoginRoute exact path="/sign" component={Sign} user={this.state.user} />
        <ManagerRoute path="/our-clients*" component={ClientsList} user={this.state.user} />
        <ManagerRoute path="/req-clients" component={ReqClientsList} user={this.state.user} />
        <ManagerRoute path="/arc-clients" component={ArchiveClientsList} user={this.state.user} />

        <ProtectedRoute path="/user/cars" component={UserCars} user={this.state.user} />

        <AdminRoute path="/stats" component={ClientsStats} user={this.state.user} />
        <AdminRoute path="/admin/managers" component={Managers} user={this.state.user} />

        <AdminRoute path="/crm" component={Crm} user={this.state.user} />
        <Redirect path="/admin" exact to={'/admin/managers'} />

        {this.mainPage()}
      </Switch>
    );
  }

  mainPage() {
    if (!this.state.user) {
      return <Redirect exact path="/" to="/login" />;
    }
    if (this.state.user.user.status === 'registered') {
      return <Redirect exact path="/" to="/sign" />;
    }

    let to = '';
    if (this.state.user.user.type === 'user') {
      to = '/user/cars';
    } else {
      to = '/our-clients'
    }

    return <Redirect exact path="/" to={to} />;
  }
}

export default App



// WEBPACK FOOTER //
// ./src/app.js